/**
* @class AddUnlinkedTransferAccountFormUI
* @classdesc Class definition for controlling what elements are rendered.
* @param {makeTransfer} _form - instance of the form which is used to create an unlinked account.
*/
export default class AddUnlinkedTransferAccountFormUI {
    _form;
    _accountNickname;
    _accountOwnerType;
    _firstNameOfAccountOwner;
    _lastNameOfAccountOwner;
    _accountType;
    _accountNumber;
    _confirmAccountNumber;
  
    constructor(form, options) {
        this._form = form;
        this.accountNickname = true;
        this.accountOwnerType = options.acctownertypedd_abi22 === "true";
        this.firstNameOfAccountOwner = options.firstnamefield_abi22 === "true";
        this.lastNameOfAccountOwner = options.lastnamefield_abi22 === "true";
        this.accountType = true;
        this.accountNumber = true;
        this.confirmAccountNumber = true;
    }

    /**
    * @name accountNickname
    * @instance
    * @property set {STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set accountNickname(value) {
        this._accountNickname = value;
    }

    /**
    * @name accountOwnerType
    * @instance
    * @property set {STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set accountOwnerType(value) {
        this._accountOwnerType = value;
    }

    /**
    * @name firstNameOfAccountOwner
    * @instance
    * @property set {STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set firstNameOfAccountOwner(value) {
        this._firstNameOfAccountOwner = value;
    }

    /**
    * @name lastNameOfAccountOwner
    * @instance
    * @property set {STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set lastNameOfAccountOwner(value) {
        this._lastNameOfAccountOwner = value;
    }

    /**
    * @name accountType
    * @instance
    * @property set {STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set accountType(value) {
        this._accountType = value;
    }

    /**
    * @name accountNumber
    * @instance
    * @property set {NUMBER|STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set accountNumber(value) {
        this._accountNumber = value;
    }

    /** 
    * @name confirmAccountNumber
    * @instance
    * @property set {NUMBER|STRING} - Set a field value.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    set confirmAccountNumber(value) {
        this._confirmAccountNumber = value;
    }

    /** 
    * @name accountNickname
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get accountNickname() {
        return this._accountNickname;
    }

    /** 
    * @name accountOwnerType
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get accountOwnerType() {
        return this._accountOwnerType;
    }

    /** 
    * @name firstNameOfAccountOwner
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get firstNameOfAccountOwner() {
        return this._firstNameOfAccountOwner;
    }

    /** 
    * @name lastNameOfAccountOwner
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get lastNameOfAccountOwner() {
        return this._lastNameOfAccountOwner;
    }

    /** 
    * @name accountType
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get accountType() {
        return this._accountType;
    }

    /** 
    * @name accountNumber
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get accountNumber() {
        return this._accountNumber;
    }

    /** 
    * @name confirmAccountNumber
    * @instance
    * @property get {BOOLEAN} - A field.
    * @note returns true if the field should be rendered.
    * @memberof AddUnlinkedTransferAccountFormUI 
    */
    get confirmAccountNumber() {
        return this._confirmAccountNumber;
    }

    /**
     * 
     * @param {AddUnlinkedTransferAccountForm} form 
     * @param {OBJECT} branding
     * @returns this
     * static factory method for initializing AddUnlinkedTransferAccountFormUI  
     */
    static init(form, branding) {
        const options = branding ? branding.options : {};
        return new AddUnlinkedTransferAccountFormUI(form, options);
    }
}